import type { ColumnDef } from '@tanstack/react-table'
import type CrmCoreUser from '@/types/serializers/CrmCoreUser'
import { StatusBadge } from './StatusBadge'

export const columns: ColumnDef<CrmCoreUser>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'email',
    header: 'Email',
  },
  {
    accessorKey: 'team_name',
    header: 'Team',
    cell: ({ row }) => row.original.team_name ?? '—',
  },
  {
    accessorKey: 'role',
    header: 'Role',
    cell: ({ row }) => {
      const role = row.original.role
      return role.charAt(0).toUpperCase() + role.slice(1).replace('_', ' ')
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => <StatusBadge status={row.original.status} />,
    filterFn: 'equals',
  },
]
